import {mapGetters} from 'vuex'
import {constants} from '@/constants'

export default  {
  computed: {
    ...mapGetters(['userInfo'])
  },

  methods: {
    async redirect () {
      const datasource = this.userInfo.register_datasource
      const {PROFILE_STATUSES, CHECK_STATUSES, DATASOURCES }  = constants
      const profileStatus = this.userInfo.profile_status
      const checkStatus = this.userInfo.check_status


      if (this.userInfo.is_resident) {
        if(profileStatus === PROFILE_STATUSES.PART){
          if(datasource === DATASOURCES.SHARING){
            await this.goTo('register-check-data')
          } else {
            await this.goTo('register-form')
          }
        }

        if(profileStatus === PROFILE_STATUSES.FULL){

          if(datasource === DATASOURCES.SHARING){
            switch(checkStatus) {
              case CHECK_STATUSES.INITIAL:
              case CHECK_STATUSES.REVIEW:
                await this.goTo('document-sign', {status: checkStatus})
                break
              case CHECK_STATUSES.SIGNED:
                if (this.$route.matched[0].name !== 'private-cabinet') {
                  await this.goTo('private-cabinet')
                }
                break
              case CHECK_STATUSES.ERRORS:
              case CHECK_STATUSES.REJECTED:
              case CHECK_STATUSES.APPROVED:
                if(this.$route.name !== 'diya-qr-code-sign') {
                  await this.goTo('form-status', {status: checkStatus})
                }
                break
            }
          } else {
            if (this.$route.matched[0].name !== 'private-cabinet') {
              await this.goTo('private-cabinet')
            }
          }

        }
      } else {

        if(profileStatus === PROFILE_STATUSES.PART) {
          await this.goTo('register-form')
        }

        if(profileStatus === PROFILE_STATUSES.FULL) {
          switch(checkStatus) {
            case CHECK_STATUSES.INITIAL:
            case CHECK_STATUSES.REVIEW:
              await this.goTo('register-final-page')
              break
            case CHECK_STATUSES.SIGNING:
              await this.goTo('document-sign', {status: checkStatus})
              break

            case CHECK_STATUSES.SIGNED:
              if (this.$route.matched[0].name !== 'private-cabinet') {
                await this.goTo('private-cabinet')
              }
              break

            case CHECK_STATUSES.ERRORS:
            case CHECK_STATUSES.REJECTED:
            case CHECK_STATUSES.APPROVED:
              await this.goTo('form-status', {status: checkStatus})
              break
          }
        }
      }

    },
    async goTo(pathName, params) {
      if (this.$route.name !== pathName) {
        await this.$router.push({name: pathName, params})
      }
    }
  }
}
